angular.module('mtic.components.modules.moduleIframe', [])
